import { OrganizationStructureApiClient } from "src/Pages/Company/OrganizationStructure/apiClient/OrganizationStructureApiClient";
import { EmployeeFormValues } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/types/employeeTypes";

export const fetchEmploymentData = async (
  companyId: string,
  employeeId: string,
  {
    signal,
  }: {
    signal: AbortSignal | undefined;
  }
) => {
  const { data } = await OrganizationStructureApiClient.get(
    `/v1/companies/${companyId}/employees/${employeeId}/employment`,
    {
      signal,
    }
  );
  return data;
};

export const saveEmploymentData = async (
  companyId: string,
  employeeId: string,
  formData: EmployeeFormValues
) => {
  const { data } = await OrganizationStructureApiClient.put(
    `/v1/companies/${companyId}/employees/${employeeId}/employment`,
    formData
  );
  return data;
};
